import logoSrc from "@/assets/torflash-logo-blue.png";

interface LogoProps {
  className?: string;
  showText?: boolean;
  variant?: "default" | "light";
}

export default function Logo({ className = "", variant = "default" }: LogoProps) {
  return (
    <div className={`inline-flex h-3.5 items-center sm:h-4.5 ${className}`}>
      <img
        src={logoSrc}
        alt="Torflash"
        className={`h-full w-auto shrink-0 object-contain ${variant === "light" ? "brightness-0 invert" : ""}`}
      />
    </div>
  );
}
